// extracted by mini-css-extract-plugin
module.exports = {"countdown":"countdown_countdown__1mGcS"};